import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaPaintBrush,
  FaStar,
  FaRocket,
  FaMobileAlt,
  FaCheckCircle,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const AnimationVideoProductionInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Animation Video Production in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Bring Ideas to Life</Subheading>}
        heading={
          <Heading>
            Animation Video <span tw="text-primary-500">Production</span> in Bur
            Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we excel in animation video production in **Bur
            Dubai**, crafting vibrant, engaging 2D and 3D animations for brands,
            campaigns, and educational content.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1633412802994-5c058f151b66?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Animation workspace
          "https://images.unsplash.com/photo-1618004912476-29818d81ae2e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // 3D animation concept
          "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Digital artwork
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Your Animation Project"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Captivating Animation Videos in Bur Dubai"
        description="We create animations that inspire and engage."
        cards={[
          {
            icon: <FaPaintBrush color="#ff5464" size={40} />,
            title: "Creative Designs",
            description: "Unique 2D and 3D visuals tailored to your brand.",
          },
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "High-Quality Output",
            description: "Smooth, vibrant animations for all platforms.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Timely Delivery",
            description: "Fast production to meet your deadlines.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Multi-Platform Ready",
            description: "Optimized for social media, websites, and ads.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted by Clients",
            description: "Bur Dubai’s choice for animation videos.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Custom Solutions",
            description: "Explainer videos, ads, or animated stories.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Animation Video Process"
        description={
          <Description>
            We craft stunning animations with a refined process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Align with your vision and goals.</li>
              <li>Storyboarding: Sketch concepts and narratives.</li>
              <li>Design: Create characters, assets, or 3D models.</li>
              <li>Animation: Bring visuals to life with smooth motion.</li>
              <li>Delivery: Provide polished videos ready to share.</li>
              <li>Support: Offer revisions to perfect your animation.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1628348070889-cb656235b4eb?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Digital illustration
          "https://images.unsplash.com/photo-1633412802994-5c058f151b66?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Animation workspace
          "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // 3D modeling screen
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Animation Video Wins in Bur Dubai"
        description="Our animations have captivated audiences."
        cards={[
          {
            icon: <FaPaintBrush color="#ff5464" size={40} />,
            title: "Brand Engagement",
            description: "Boosted campaigns with vibrant animations.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Acclaim",
            description: "94% satisfaction from Bur Dubai clients.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Viral Impact",
            description: "Animations shared widely online.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Animate Your Story?</Subheading>}
        heading="Animation Video Production in Bur Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for expert animation video production in
            Bur Dubai. Get creative, engaging videos to elevate your
            brand—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1648387598225-1a44ef324bee?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Creative design workspace
          "https://images.unsplash.com/photo-1579403124614-197f69d8187b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Digital animation concept
          "https://images.unsplash.com/photo-1626785774625-6babb4418d56?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Animation monitor setup
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
